import { useMemo } from "react";
import { getDashboardMockData } from "@app/pages/dashboard/dashboard-mock-data";
import type { DashboardData, DashboardFilters } from "@app/pages/dashboard/dashboard-types";

/**
 * Resolves dashboard card data from the active filters.
 * Replace this hook with RTK Query once backend resolvers are available.
 */
export function useDashboardData(filters: DashboardFilters): DashboardData {
    const { globalDateRange, spendDimension, unspentView, approvalsView, chargeItemsDateRange } = filters;

    return useMemo(
        () =>
            getDashboardMockData({
                globalDateRange,
                spendDimension,
                unspentView,
                approvalsView,
                chargeItemsDateRange,
            }),
        [approvalsView, chargeItemsDateRange, globalDateRange, spendDimension, unspentView],
    );
}
